import { createReducer, on } from '@ngrx/store';
import {
  LoadSoulfileProjects,
  SetSoulfileProjects,
  LoadCurrentSoulfileProject,
  UpdateCurrentSoulfileProject,
  SetCurrentSoulfileProject,
  LoadCurrentSoulfiles,
  SetCurrentSoulfiles,
  LoadCurrentSoulfile,
  SetCurrentSoulfile,
  CreateSoulfile,
  CreateSoulfileProject,
  DeleteSoulfileProject,
  SetSoulfileError,
  SetSoulfileCsvError,
  RemoveSoulfileError,
} from './soulfile.actions';
import { SoulfileApiError } from './soulfile.errors';
import { SoulfileProject } from 'src/app/admin/models/soulfile-project.model';
import { Soulfile } from 'src/app/admin/models/soulfile.model';

export interface SoulfileState {
  projects: SoulfileProject[];
  currentProject: SoulfileProject;
  currentSoulfiles: Soulfile[];
  currentSoulfile: Soulfile;
  apiError: SoulfileApiError;
}

export const initialState: SoulfileState = {
  projects: [],
  currentProject: null,
  currentSoulfiles: null,
  currentSoulfile: null,
  apiError: null,
};

export const soulfileReducer = createReducer(
  initialState,
  on(SetSoulfileProjects, (state, { projects }) => ({ ...state, projects })),
  on(SetCurrentSoulfileProject, (state, { project }) => ({ ...state, currentProject: project })),
  on(LoadCurrentSoulfiles, (state) => ({ ...state, currentSoulfiles: null, apiError: null })),
  on(SetCurrentSoulfiles, (state, { soulfiles }) => ({ ...state, currentSoulfiles: soulfiles })),
  on(SetCurrentSoulfile, (state, { soulfile }) => ({ ...state, currentSoulfile: soulfile })),
  on(
    DeleteSoulfileProject,
    RemoveSoulfileError,
    CreateSoulfileProject,
    CreateSoulfile,
    LoadSoulfileProjects,
    LoadCurrentSoulfileProject,
    UpdateCurrentSoulfileProject,
    LoadCurrentSoulfile,
    (state) => ({ ...state, apiError: null }),
  ),
  on(SetSoulfileError, (state, { error }) => ({ ...state, apiError: error })),
  on(SetSoulfileCsvError, (state, { error }) => ({ ...state, apiError: error })),
);
